import { SKU } from '@/models/sku';
import Fuse from 'fuse.js';

export type FuseGoodsType = { id: number; namePy: string; namePyShort: string };

export type SearchGoodsOptions = Fuse.FuseSearchOptions;
export type SearchGoodsFuncType = {
  (pattern: string | Fuse.Expression, options?: Fuse.FuseSearchOptions): Fuse.FuseResult<
    FuseGoodsType
  >[];
};

export const fuseGoodsOptions = {
  isCaseSensitive: false,
  includeScore: true,
  threshold: 0.15,
  keys: [
    {
      name: 'namePy',
      weight: 1,
    },
    { name: 'namePyShort', weight: 1 },
    {
      name: 'sn',
      weight: 0.1,
    },
  ],
};

export const goodsToSearchDoc = (item: SKU) => {
  const namePy = item.namePy || '';
  return {
    id: item.id,
    namePy: namePy.replace(/ /g, ''),
    namePyShort: namePy
      .split(' ')
      .map(str => str.substring(0, 1))
      .join(''),
    sn: item.goodsSn,
  };
};
